/* eslint-disable */
const PRECISE_PATTERN = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
const BASIC_PATTERN = /^\S+@\S+\.\S+$/
/* eslint-enable */
module.exports = function checkEmail (value) {
  if (typeof value !== 'string') {
    return false
  }
  const mode = 'precise'
  let pattern
  if (mode === 'precise') {
    pattern = PRECISE_PATTERN
  } else {
    pattern = BASIC_PATTERN
  }
  if (!pattern.test(value)) {
    return false
  }

  return true
}
